import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AdminDashboardData, FsrDashboardData } from '../models/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getUnifiedDashboardData(dateFilter?: { startDate?: string, endDate?: string, period?: 'today' | 'thisWeek' | 'thisMonth' | 'last30Days' | 'custom' }): Observable<AdminDashboardData> {
    let url = `${environment.apiUrl}/dashboard/unified`;
    const params = new URLSearchParams();
    
    if (dateFilter?.period) {
      params.append('period', dateFilter.period);
    }
    if (dateFilter?.startDate) {
      params.append('startDate', dateFilter.startDate);
    }
    if (dateFilter?.endDate) {
      params.append('endDate', dateFilter.endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return this.http.get<{success: boolean, message: string, data: AdminDashboardData}>(url)
      .pipe(
        map(response => response.data)
      );
  }

  getAdminDashboardData(dateFilter?: { startDate?: string, endDate?: string, period?: 'today' | 'thisWeek' | 'thisMonth' | 'last30Days' | 'custom' }): Observable<AdminDashboardData> {
    let url = `${environment.apiUrl}/dashboard/admin`;
    const params = new URLSearchParams();
    
    if (dateFilter?.period) {
      params.append('period', dateFilter.period);
    }
    if (dateFilter?.startDate) {
      params.append('startDate', dateFilter.startDate);
    }
    if (dateFilter?.endDate) {
      params.append('endDate', dateFilter.endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return this.http.get<{success: boolean, message: string, data: AdminDashboardData}>(url)
      .pipe(
        map(response => response.data)
      );
  }

  getFsrDashboardData(dateFilter?: { startDate?: string, endDate?: string, period?: 'today' | 'thisWeek' | 'thisMonth' | 'last30Days' | 'custom' }): Observable<FsrDashboardData> {
    let url = `${environment.apiUrl}/dashboard/fsr`;
    const params = new URLSearchParams();
    
    if (dateFilter?.period) {
      params.append('period', dateFilter.period);
    }
    if (dateFilter?.startDate) {
      params.append('startDate', dateFilter.startDate);
    }
    if (dateFilter?.endDate) {
      params.append('endDate', dateFilter.endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return this.http.get<{success: boolean, message: string, data: FsrDashboardData}>(url)
      .pipe(
        map(response => response.data)
      );
  }

  getFsrDashboardCustomers(dateFilter?: { startDate?: string, endDate?: string, period?: 'today' | 'thisWeek' | 'thisMonth' | 'last30Days' | 'custom' }): Observable<{customers: any[], totalCount: number}> {
    let url = `${environment.apiUrl}/dashboard/fsr/customers`;
    const params = new URLSearchParams();
    
    if (dateFilter?.period) {
      params.append('period', dateFilter.period);
    }
    if (dateFilter?.startDate) {
      params.append('startDate', dateFilter.startDate);
    }
    if (dateFilter?.endDate) {
      params.append('endDate', dateFilter.endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return this.http.get<{success: boolean, message: string, data: {customers: any[], totalCount: number}}>(url)
      .pipe(
        map(response => response.data)
      );
  }

}
